<template>
  <li
    v-if="canViewVerticalNavMenuLink(item) && acessoModuloLink(item)"
    class="nav-item"
    :class="{
      active: isActive,
      disabled: item.disabled
    }"
  >
    <!-- Link do item -->
    <b-link
      :id="tooltipTargetId"
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <feather-icon :icon="item.icon || 'CircleIcon'" />

      <span class="menu-title text-truncate">
        {{ t(item.title) }}
      </span>

      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>

    <!-- Tooltip (aparece só com o menu recolhido) -->
    <b-tooltip
      :target="tooltipTargetId"
      placement="right"
      boundary="window"
      :disabled="!isVerticalMenuCollapsed"
      triggers="hover focus"
    >
      {{ tooltipText }}
    </b-tooltip>
  </li>
</template>

<script>
import { BLink, BBadge, BTooltip } from 'bootstrap-vue'
import { inject, ref, computed } from '@vue/composition-api'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import { acessoModuloLink } from '@/auth/utils'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  name: 'VerticalNavMenuLink',
  components: { BLink, BBadge, BTooltip },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: { type: Object, required: true },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)

    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuLink } = useAclUtils()

    const isVerticalMenuCollapsed = inject('isVerticalMenuCollapsed', ref(false))

    const tooltipText = computed(() => (props.item && props.item.tooltip ? t(props.item.tooltip) : t(props.item.title)))

    const tooltipTargetId = computed(() => {
      const base = (props.item.title || 'menu-item').toString().toLowerCase().replace(/\s+/g, '-')
      const extra = (props.item.icon || props.item.route || '').toString().toLowerCase().replace(/\s+/g, '-')
      return `menu-link-${base}-${extra}`
    })

    return {
      isActive,
      linkProps,
      updateIsActive,
      t,
      canViewVerticalNavMenuLink,
      isVerticalMenuCollapsed,
      tooltipText,
      tooltipTargetId,
      acessoModuloLink,
    }
  },
}
</script>

<style></style>
